import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'

export const FromManualAdd = () => {
  return (
    <Provider>
      <Layout />
    </Provider>
  )
}
